import React from 'react';
import styled from 'styled-components';
import AMSSwiper from './AMSSwiper';
import Grid from '../Grid/Grid';
import { OFFERS } from '../../../../lib/constants';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';

const Gutter = styled.div`
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: ${p => p.theme.unit(7)};
  padding-bottom: ${p => p.theme.unit(1)};
`;

const IndexAbsPositionDiv = styled.div`
  position: absolute;
  bottom: ${p => p.theme.unit(1)};
  left: ${p => p.theme.unit(1)};
  right: auto;
  top: auto;
`;

const Carousel = ({
  Comp,
  items,
  itemType,
  removeItemHandler,
  saveItemHandler,
  pageStateModifiers,
  locale,
  carouselKey,
  mobileGridStyle,
  spaceBetweenSlides,
}) => {
  let slidesPerView = null;
  let slidesPerGroup = null;
  let breakpoints = null;
  if (itemType === OFFERS) {
    slidesPerView = 4;
    slidesPerGroup = 4;
    breakpoints = {
      1000: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1300: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    };
  } else {
    slidesPerView = 3;
    slidesPerGroup = 3;
    breakpoints = {};
  }

  const itemsToDisplay = items && items.length >= 1 && items.map(
    (item, index) => {
      const layoutKey = `carousel-${index}-${item.id}`;

      return (
        <Gutter key={layoutKey}>
          <Comp
            {...item}
            removeItemHandler={removeItemHandler}
            saveItemHandler={saveItemHandler}
            pageStateModifiers={pageStateModifiers}
            locale={locale} 
            idPrefix="carousel" />

          {/* Display index of each card for debugging purposes */}
          {/* <IndexAbsPositionDiv> */}
          {/* { index + 1} */}
          {/* </IndexAbsPositionDiv> */}
        </Gutter>);
    });

  // switch to 1 column grid view in mobile
  const DesktopBody = () => (
    <AMSSwiper
      breakpoints={breakpoints}
      slidesPerGroup={slidesPerGroup}
      slidesPerView={slidesPerView}
      navigationKey={carouselKey}
      spaceBetween={spaceBetweenSlides}
    >
      {itemsToDisplay}
    </AMSSwiper>
  );

  const MobileBody = () => (
    <Grid
      items={items}
      Comp={Comp}
      removeItemHandler={removeItemHandler}
      saveItemHandler={saveItemHandler}
      pageStateModifiers={pageStateModifiers}
      locale={locale}
      styleMobile={mobileGridStyle}
    />
  );

  const renderComp = (<MediaQueryHelper
    desktopChildren={DesktopBody()}
    mobileChildren={MobileBody()} />);

  return renderComp;
};

export default Carousel;
